import React, { Component } from 'react';
import PropTypes from 'prop-types';

import firebase from '../helpers/firebase';
import { TABLE_NAME } from '../helpers/constants';

const db = firebase.database();

class MakeUpRow extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props, context) {
    super(props, context);

    this.state = {
      user: {},
    };

    if (this.props.showName && this.props.makeup.userId) {
      db.ref(TABLE_NAME.USERS).child(this.props.makeup.userId).once('value').then((snapshot) => {
        let user = snapshot.val();
        user.id = snapshot.key;
        this.setState({ user });
      });
    }

    this.cancel = this.cancel.bind(this);
  }


  render() {

    const { makeup, showName } = this.props

    return (
      <tr>
        { showName ? <td>{ this.state.user ? this.state.user.name : '' }</td> : null}
        <td>{makeup.date}</td>
        <td>{makeup.hours}</td>
        <td>{makeup.requestedBy.name}</td>

      </tr>
    )
  }

  cancel() {
    return db.ref(TABLE_NAME.MAKEUPS).child(this.props.makeup.id).remove().then(() => {
      // update handled in getTimeOffHistory
    });
  }
}

export default MakeUpRow;



// WEBPACK FOOTER //
// ./src/components/MakeUpRow.js